import axios from 'axios'
import store from '@/store'

export const api = axios.create({
  timeout: 60000,
  baseURL: process.env.VUE_APP_API_URL,
  'Content-Type': 'application/json',
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { data } = error.response

    if (data.code === 'INTERNAL_SERVER_ERROR') {
      store.commit('setToasterMessage', data?.message)
    }

    return Promise.reject(error.response)
  }
)
